"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSaveSearchPageState = exports.defaultNotificationSettings = void 0;
var UserSearchSet_init_1 = require("@/pages/common/states/UserSearchSet.init");
var HfilterDistrictItem_init_1 = require("@/pages/search/states/HfilterDistrictItem.init");
exports.defaultNotificationSettings = {
    id: 123,
    enabled: true,
    freq: 'daily',
};
exports.defaultSaveSearchPageState = {
    nameTitle: 'Saved Search',
    nameCaption: 'Manage your saved searches',
    nameArea: 'Area',
    nameLayout: 'Property',
    nameDistrict: 'District',
    nameBed: 'Bedrooms',
    namePrice: 'Price',
    nameAmenity: 'Features',
    nameKeyword: 'Keyword',
    nameSize: 'Size',
    nameEmptyTitle: 'No saved search yet!',
    nameEmptyCaption: 'Your saved search criterias will be shown here',
    nameEmptyStartNew: 'You can start a new search and click `Save Search` to begin with',
    nameEmptySearchNow: 'Start a new search now',
    nameType: 'Type',
    nameBuy: 'Buy',
    nameRent: 'Rent',
    nameAll: 'Buy / Rent',
    nameGross: 'Gross',
    nameSaleable: 'Saleable',
    nameFt: 'ft.',
    nameStudio: 'Studio',
    nameMaidRoom: 'Maid\'s Room',
    nameCarpark: 'Carpark',
    nameOutdoor: 'Outdoor Space',
    nameAndMore: 'and more',
    nameEdit: 'Edit',
    nameSort: 'Sort',
    nameEmailFreq: 'Updates',
    nameAbove: 'Above',
    nameBelow: 'Below',
    nameEditSaveSearch: 'Edit Save Search',
    nameFreq: {
        off: 'Off',
        daily: 'Daily',
        weekly: 'Weekly',
    },
    nameViewListing: 'View Listing',
    nameLanguage: 'Language',
    nameCurrency: 'Currency',
    districts: HfilterDistrictItem_init_1.defaultHfilterDistrictItems,
    isDim: false,
    isActive: false,
    isLoading: false,
    newName: '',
    currentId: 0,
    currentNotificationSettings: exports.defaultNotificationSettings,
    searchSets: [
        UserSearchSet_init_1.defaultMapSearch,
        UserSearchSet_init_1.defaultUserSearchSetSaleType,
        UserSearchSet_init_1.defaultUserSearchSetRentType,
        UserSearchSet_init_1.defaultUserSearchSetFollowBuildingType,
        UserSearchSet_init_1.defaultUserSearchSetFollowDistrictType,
    ],
};
